export var getZoneName = function (state) { return state.zone.name; };
export var getZonePoint = function (state) { return state.zone.point; };
